import { render, staticRenderFns } from "./facebook_ad_fields.vue?vue&type=template&id=2ba47ed9&"
import script from "./facebook_ad_fields.vue?vue&type=script&lang=js&"
export * from "./facebook_ad_fields.vue?vue&type=script&lang=js&"
import style0 from "./facebook_ad_fields.vue?vue&type=style&index=0&id=2ba47ed9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports